// extracted by mini-css-extract-plugin
export var basicLinkButton = "TextLink-module__basicLinkButton___BkB4c";